<template>
  <div id="banner" v-if="$store.state.loggedUser" :class="{ hidden: !$store.getters.isMenuVisible(this.$route) }">
    <svgicon src="icon/logo-ishopfood.svg" :height="24"></svgicon>
    <svgicon src="icon/logo-payfacto.svg" :height="18"></svgicon>
    <div class="grow"></div>
    <div class="action">
      <ActionMenu icon="/icon/profile-white.svg">
        <div href="javascript:void(0)" class="item locale">
          <span v-for="locale in $ts.getters.getLocales" :key="locale" :class="{ active: $ts.state.locale === locale }"
            @click="$ts.commit('setLocale', locale)">
            {{ locale.toUpperCase() }}
          </span>
        </div>
        <a href="javascript:void(0)" class="item" @click="logout">{{ $t("logout") }}</a>
      </ActionMenu>
    </div>
  </div>
</template>

<script>
  import ActionMenu from './tools/ActionMenu.vue';

  export default {
    name: 'banner',
    components: { ActionMenu },
    methods: {
      logout() {
        this.$store.commit('logOut');
        this.$router.push("/login");
      }
    }
  };
</script>

<style lang="scss" scoped>
  #banner {
    grid-column: span 2;
    background-color: #FC6650;
    display: flex;
    align-items: center;
    padding: 0 16px;
    fill: white;

    .grow {
      flex-grow: 1;
    }
  }

  .svgicon {
    margin-right: 16px;
    fill: white;

    &:first-child {
      margin-right: 0;

      &::after {
        content: '';
        display: block;
        width: 1px;
        height: 16px;
        background-color: white;
        margin: 0 16px;
      }
    }
  }

  .locale {
    display: flex;
    justify-content: space-around;

    span {
      margin: 0 4px;
    }

    .active {
      font-weight: bold;
    }
  }
</style>